enum AssetType {
  LOGO = 'LOGO',
  LOGO_BW = 'LOGO_BW',
  PROMO = 'PROMO',
  RECOMMENDATION = 'RECOMMENDATION',
  PROMO_DELIVERED = 'PROMO_DELIVERED',
  SPOTLIGHT_DELIVERED = 'SPOTLIGHT_DELIVERED',
  SPOTLIGHT_VIDEO_DELIVERED = 'SPOTLIGHT_VIDEO_DELIVERED',
  RECOMMENDATION_DELIVERED = 'RECOMMENDATION_DELIVERED',
}

type JSONAsset = {
  object_id: string;
  type: string;
  title: Maybe<string>;
  link_url: Maybe<string>;
  image_url: string;
  draft_image_url: string;
  rank: Maybe<number>;
};

type Asset = {
  objectId: string;
  type: AssetType;
  title: Maybe<string>;
  linkUrl: Maybe<string>;
  imageUrl: string;
  draftImageUrl: string;
  rank: Maybe<number>;
};

function fromJSON(jsonAsset: JSONAsset): Asset {
  return {
    objectId: jsonAsset.object_id,
    type: <AssetType>jsonAsset.type,
    rank: jsonAsset.rank,
    title: jsonAsset.title,
    linkUrl: jsonAsset.link_url,
    imageUrl: jsonAsset.image_url,
    draftImageUrl: jsonAsset.draft_image_url,
  };
}

function toJSON(asset: OptionalObjectId<Asset>): OptionalObjectIdJSON<JSONAsset> {
  return {
    object_id: asset.objectId,
    type: asset.type,
    rank: asset.rank,
    title: asset.title,
    link_url: asset.linkUrl,
    image_url: asset.imageUrl,
    draft_image_url: asset.draftImageUrl,
  };
}

export { Asset, AssetType, JSONAsset, fromJSON, toJSON };
